<template>
  <v-row align="center" justify="center">
    <v-card max-width="1200" width="94%">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <img src="@/assets/of-logo.png" alt="Outfox AI" width="100px" class="img-rounded">
          </v-col>
          <v-col cols="12">
            <v-card
              tile
              text
              class="my-5"
              height="250"
            >
              <img :src="pictureLink" alt="Outfox AI" class="ma-auto">
            </v-card>
          </v-col>
          <v-col cols="12">
            <div class="text-center headline grey--text text--darken-2 mb-5">
              {{ step.text }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="currentStepDecrement"
        >
          Previous
        </v-btn>
        <v-spacer />
        <div class="controls">
          <v-btn
            icon
            small
            class="controls__btn"
            v-for="n in 3"
            :key="n"
            :class="activeClass(n)"
            @click="setStep(n)"
          >
            <v-icon small>fiber_manual_record</v-icon>
          </v-btn>
        </div>
        <v-spacer />
        <v-btn
          color="primary"
          style="width: 126px"
          @click="currentStepIncrement"
        >
          {{step.id < 3 ? 'Next' : 'Let\'s go'}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
  export default {
    name: 'GettingStartedStepper',
    props: {
      step: {
        props: Object,
        default: () => {}
      }
    },
    computed: {
      pictureLink () {
        return require(`@/assets/img/${this.step.image}`)
      }
    },
    methods: {
      activeClass (id) {
        if (Number(this.step.id) === Number(id)) return 'active'
        return ''
      },
      currentStepDecrement () {
        this.$emit('currentStepDecrement')
      },
      currentStepIncrement () {
        this.$emit('currentStepIncrement')
      },
      setStep (step) {
        this.$emit('setStep', step)
      }
    }
  }
</script>
<style lang="scss">
  .controls__btn.active .v-icon {
    color: #3172d1!important;
    opacity: 1;
  }
</style>
